import { Requests } from "../common/request.common";
import { DeviceResponseTypes, UserBioResponseTypes } from "../common/response.common";
import { get, post } from "./common";

export const userBio = {
    obtain(id: string) {
        return get<UserBioResponseTypes.Obtain>(`/user-bio/obtain/${id}`);
    },
    addPhoto(id: string, data: typeof Requests.UserBio.SetPhoto.Input) {
        return post<typeof data, DeviceResponseTypes.RunCommand>(`/user-bio/add-photo/${id}`, data);
    },
    enrollFinger(id: string, data: typeof Requests.UserBio.EnrollFinger.Input) {
        return post<typeof data, DeviceResponseTypes.RunCommand>(
            `/user-bio/enroll-finger/${id}`,
            data,
        );
    },
    syncFinger(id: string, data: typeof Requests.UserBio.SyncFinger.Input) {
        return post<typeof data, DeviceResponseTypes.RunCommand>(
            `/user-bio/sync-finger/${id}`,
            data,
        );
    },
    activate(id: string, data: typeof Requests.UserBio.Activate.Input) {
        return post<typeof data, UserBioResponseTypes.Activate>(`/user-bio/activate/${id}`, data);
    },
};
